import { MenuButton, MenuItemWithIcon } from "@msys/ui";
import { BugReport as BugReportIcon } from "@mui/icons-material";
import { useTranslate } from "@tolgee/react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { RestrictedByOrganisationPermissionWithDebug } from "../../../auth/RestrictedByOrganisationPermission.js";
import { DuplicateTemplateMenuItem } from "../buttons/DuplicateTemplateMenuItem.js";
import { ExportTemplatesMenuItem } from "../buttons/ExportTemplatesMenuItem.js";
import { ShowTemplateVariantProtocolButton } from "./buttons/ShowTemplateVariantProtocolButton.js";
import { TemplateQuoteTemplateStoreMenu_QuoteTemplateFragment } from "./TemplatesQuoteTemplateStoreMenu.generated.js";

interface Props {
  doc: TemplateQuoteTemplateStoreMenu_QuoteTemplateFragment;
  pathToDoc: string;
  pathToDocList: string;
  pathToDocVersion: string;
  onDuplicateRefetchQueries?: string[];
  onUpdateDataRefetchQueries?: string[];
}

export const TemplatesQuoteTemplateStoreMenu = ({
  doc,
  pathToDoc,
  pathToDocList,
  pathToDocVersion,
  onDuplicateRefetchQueries,
  onUpdateDataRefetchQueries,
}: Props) => {
  const { t } = useTranslate(["Global", "Templates", "Quote"]);
  const navigate = useNavigate();

  return (
    <MenuButton>
      <RestrictedByOrganisationPermissionWithDebug permission="MANAGE_ORG">
        <ExportTemplatesMenuItem
          docIds={[
            {
              docId: doc.id,
              versionNumber: doc.resolvedAsReadModelVersionNumber ?? null,
            },
          ]}
          title={t("Export template", { ns: "Quote" })}
        />
      </RestrictedByOrganisationPermissionWithDebug>
      {doc.templateSharing?.subscribedToTemplate ? (
        <RestrictedByOrganisationPermissionWithDebug permission="MANAGE_TEMPLATE">
          <DuplicateTemplateMenuItem
            doc={doc}
            pathToDocList={pathToDocList}
            onDuplicateRefetchQueries={onDuplicateRefetchQueries}
          />
        </RestrictedByOrganisationPermissionWithDebug>
      ) : null}
      <RestrictedByOrganisationPermissionWithDebug permission="MANAGE_TEMPLATE">
        <MenuItemWithIcon
          icon={<BugReportIcon />}
          onClick={() => navigate(`${pathToDocVersion}/troubleshoot`)}
        >
          {t("Troubleshoot", { ns: "Global" })}
        </MenuItemWithIcon>
      </RestrictedByOrganisationPermissionWithDebug>
      {doc.customizable && (
        <RestrictedByOrganisationPermissionWithDebug permission="MANAGE_TEMPLATE">
          <ShowTemplateVariantProtocolButton
            templateId={doc.id}
            versionNumber={doc.resolvedAsReadModelVersionNumber ?? 0}
            pathToDocList={pathToDocList}
            type="menu-item"
          />
        </RestrictedByOrganisationPermissionWithDebug>
      )}
    </MenuButton>
  );
};
